/* eslint-disable */

import { arrayIntersection } from '@/utils/array';

/**
 * Aliasing Object[method] allows the minifier to shorten methods to a single character variable,
 * as well as giving BV a chance to inject polyfills.
 * As long as we avoid
 * - import * as Object from "utils/object"
 * all unused exports should be removed by tree-shaking.
 */

// @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) {
            // .length of function is 2

            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError(
                    'Cannot convert undefined or null to object'
                );
            }

            const to = Object(target);

            for (let index = 1; index < arguments.length; index++) {
                const nextSource = arguments[index];

                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (const nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (
                            Object.prototype.hasOwnProperty.call(
                                nextSource,
                                nextKey
                            )
                        ) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true,
    });
}

// @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#Polyfill
if (!Object.is) {
    Object.is = function(x, y) {
        // SameValue algorithm
        if (x === y) {
            // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
        }
        // Step 6.a: NaN == NaN
        // eslint-disable-next-line no-self-compare
        return x !== x && y !== y;
    };
}

export function readonlyDescriptor() {
    return { enumerable: true, configurable: false, writable: false };
}

export function definePropertyOrAssign(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

export function isObject(val) {
    return typeof val === 'object'
        && val !== null
        && !Array.isArray(val);
}

export function objectKeyIntersection(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    return arrayIntersection(keys1, keys2);
}

/**
 * Walks through each object property, including nested properties, and executes the specified callback function.
 *
 * Args:
 *      obj (Object): The object to walk through.
 *      callback (Function): A callback function to execute on each property. The following arguments are passed to it:
 *          parentObject (Object): A reference to the parent object.
 *          key (String): The property name.
 *          value (String): The property value.
 *
 * Example:
 *      const obj = {
 *          foo: 'hello',
 *          bar: {
 *              baz: 'world',
 *          },
 *      };
 *
 *      // logs "hello" and "world"
 *      walkObject(obj, (parentObject, key, value) => {
 *          console.log(value);
 *      });
 */
export function walkObject(obj, callback) {
    function walk(parentObj) {
        
        Object.entries(parentObj).forEach((entry) => {
            const [key, value] = entry;

            callback(parentObj, key, value);

            if (value && typeof value === 'object') walk(value)
        });
    }

    walk(obj);
}

export function getJsonFromNvList(nvList) {
    return nvList.reduce((obj, nv) => {
        obj[nv.name] = nv.value;

        return obj;
    }, {});
}

/*
    
*/
export function getNameValueListFromJson(obj) {
    return Object.entries(obj).map((item) => {
        return {
            name: item[0],
            value: item[1],
        };
    });
}